import Cookies from "js-cookie";
import { _API_URL, _API_URL_AGENT, _API_URL_GOOGLE_CLOUDE } from "./constants";
import { openLoading, closeLoading } from "./loading";
import { CHECK_WARNING } from "../components/alert/Alert";
import { logoutAccount } from "../routes/permission";
import CryptoJS from "crypto-js";
import { JSEncrypt } from "jsencrypt";
import { Buffer } from "buffer";

function randomBytes(length = 32) {
  return Array(length)
    .fill(0)
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join("");
}

const pemEncodedKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAytaTLYG7guDbHfm3oHrU
fqTmuhQDleUrp1ZZE/bpKPUSWwmqZkBY/wPPEoINYQnKzd1u//70RtMwondHQR0q
MIVnUMSZiGoPJghGojemPXqIWyqfwYPRJqI0fp9jiQbj49SOpgthBTS5onqiK3t1
GgmsyFl0y/zS5FCRfZazuzZLmj/ss2Wwq2benAJavEQpt5vfpSqkXpCAYttH1WdG
inhrhZud8qgLY3sPWbX32UkMdnT+hvRgOdPOpG6XKWFR2HLCHLL9XCJqvq7Qkkux
/bNOZ4rk21TbnMty9t6Z9lA9daCMX7NiABVsyP1pf3Y9PRtIK7Fx63hgoItd27WD
RwIDAQAB
-----END PUBLIC KEY-----`;

export function encryptKeyWithRsaPublicKey(privateKey, symmetricKey) {
  var encrypt = new JSEncrypt();
  encrypt.setPublicKey(privateKey);
  // const buffer = str2ab(symmetricKey);
  // const encrypted = cryptobrowserify.pu (pemEncodedKey, buffer);
  var encrypted = encrypt.encrypt(symmetricKey);
  return encrypted;
}

function encryptData(key, iv, data) {
  const cipher = CryptoJS.algo.AES.createEncryptor(
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: CryptoJS.enc.Utf8.parse(iv),
    }
  );
  const encrypted = cipher.process(data);
  const ciphertext = CryptoJS.enc.Base64.stringify(
    encrypted.concat(cipher.finalize())
  );
  return ciphertext;
}

/**
 * @module src/actions/callApi
 * @typedef {Object} ExportFetchType
 * @property {string} prefix // Địa chỉ REST API server, để trống nếu `url` chứa đường dẫn đầy đủ
 * @property {string} url // Đường dẫn chính xác của API
 * @property {string} [method='GET'] // Phương thức gọi API
 * @property {BodyInit} [body=null] // Dữ liệu gửi lên API
 * @property {boolean} [noAlert=false] // Tắt bật alert nếu gọi API thất bại
 * @property {boolean} [noLoading=false]
 * @property {'json' | 'text' | 'blob' | 'arrayBuffer'} [responseType='blob'] // Loại dữ liệu trả về [json, text, arrayBuffer, blob]
 * @property {string=} refreshToken
 */

/**
 * Cấu hình fetch API
 * @param {string} method
 * @param {BodyInit | null} body
 * @param {boolean} auth
 * @param {string} refreshToken
 */
export const exportConfigsFetch = (
  method,
  body,
  auth,
  refreshToken,
  typeEndpoint
) => {
  /** @type {RequestInit} */
  const configs = {
    method,
    credentials: "same-origin", // <-- includes cookies in the request
    headers: {
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json,*/*",
      "X-GDT-Dev-Token": import.meta.env.REACT_APP_DEV_TOKEN,
    },
  };
  let token = auth ? Cookies.get("GDTECABINET") : "";
  const IPADDRESS = Cookies.get("IP_Client");

  switch (typeEndpoint) {
    case "google":
      token = Cookies.get("PARTNER_ACCESS_TOKEN");
      delete configs.headers["X-GDT-Dev-Token"];
      break;
    case "agent":
      token = Cookies.get("PARTNER_ACCESS_TOKEN");
      delete configs.headers["X-GDT-Dev-Token"];
      break;
    default:
      configs.headers["X-Forwarded-For"] = IPADDRESS;
      break;
  }

  if (refreshToken) configs["cookies"] = Cookies.get("refreshToken");

  // if (token) {
  //   configs.headers["Authorization"] = `Bearer ${token}`;
  // }
  if (method !== "GET") {
    if (
      method === "POST" ||
      method === "PUT" ||
      method === "PATCH" ||
      method === "DELETE"
    ) {
      if (body) {
        configs["body"] = body;
        configs.headers["Content-Type"] = "application/json";
      }
    }
  }
  return configs;
};

/**
 * Cấu hình header in batch Api
 * @param {string} method
 * @param {BodyInit | null} body
 * @param {boolean} auth
 */
export const exportConfigHeader = (method, auth) => {
  /** @type {RequestInit} */
  const headers = {};
  if (method !== "GET") {
    headers["Content-Type"] = "application/json";
  }
  return headers;
};

/**
 * Tạo body cho request with batch Odata
 * @param {string} urlBatch
 * @param {string} method
 * @param {array} data
 */
export function CreateListFetch(urlEndpoint, dataRequest) {
  if (Array.isArray(dataRequest)) {
    let rq = [];
    dataRequest.forEach((b, i) => {
      const { data: body, method } = b;
      let url = body.id ? urlEndpoint + `(${body.id})` : urlEndpoint;
      if (method === "PATCH") {
        url = urlEndpoint + `(${body.id})`;
        delete body["id"];
      }
      rq.push({
        id: `${i + 1}`,
        method,
        url,
        body,
        headers: exportConfigHeader(method, true),
      });
    });
    return JSON.stringify({ requests: rq });
  }
  return [];
}

export const encryptFunc = ({ endpoint, body, data }) => {
  const symmetricKey = randomBytes(32);
  const iv = randomBytes(16);
  const encryptedKey = encryptKeyWithRsaPublicKey(
    pemEncodedKey,
    JSON.stringify({
      key: symmetricKey,
      iv,
    })
  );
  if (endpoint) {
    const matches = endpoint.split("?");
    if (matches.length > 1) {
      const encryptedParam = encryptData(symmetricKey, iv, "?" + matches[1]);
      matches[1] = Buffer.from(
        JSON.stringify({ encryptedData: encryptedParam, encryptedKey })
      ).toString("base64");
      endpoint = matches.join("?data=");
    }
  }

  if (body) {
    const encryptedData = encryptData(symmetricKey, iv, body);
    body = JSON.stringify({ encryptedData, encryptedKey });
  }
  if (data) {
    const encryptedData = encryptData(symmetricKey, iv, data);
    data = JSON.stringify({ encryptedData, encryptedKey });
  }
  return { mainEndpoint: endpoint, mainBody: body, mainData: data };
};

/**
 * Gọi Fetch API
 * @param {ExportFetchType} conf
 */
const exportFetch = ({
  prefix = "",
  url,
  method = "GET",
  body = null,
  noAlert,
  noLoading,
  responseType = "json",
  refreshToken,
  endpoint,
  isBatch,
  isDataError,
  deep = 0,
  typeEndpoint = "default",
}) => {
  if (method !== "GET" && !noLoading) openLoading();
  const auth = prefix && url.indexOf("/public") === -1;
  // const encodedUrl = url.replace(/(?<=search=)[^&]+/g, m => {
  //     if (decodeURIComponent(m) === m) return encodeURIComponent(m);
  //     return m;
  // });

  let bodyBatch = null;
  if (isBatch) bodyBatch = CreateListFetch(endpoint, body);
  let host = null;
  switch (typeEndpoint) {
    case "google":
      host = `${_API_URL_GOOGLE_CLOUDE}${url}`;
      break;
    case "agent":
      host = `${_API_URL_AGENT}${url}`;
      break;
    default:
      host = `${prefix}${url}`;
      break;
  }
  // let { mainEndpoint, mainBody } = encryptFunc({ endpoint: host, body });

  return fetch(
    host,
    exportConfigsFetch(method, (bodyBatch || body), auth, refreshToken, typeEndpoint)
  )
    .then(async (response) => {
      if (response.status >= 200 && response.status < 300) {
        if (response.status === 204) return response;
        if (response.status === 205)
          return await Promise.resolve(response[responseType]());
        if (method === "DELETE") {
          return await Promise.resolve(response);
        } else if (url.includes("Upload/Download")) {
          return await Promise.resolve(response.blob());
        } else {
          return await Promise.resolve(response[responseType]());
        }
      } else if (response.status === 500) {
        // if (deep < 1) {
        //     deep++;
        //     return exportFetch({ prefix, url, method, body, noAlert, noLoading, responseType, refreshToken, endpoint, isBatch, deep })
        // }
        // CHECK_ERROR('Liên hệ GDT!')
        return Promise.reject(false);
      } else if (response.status === 401) {
        logoutAccount();
      } else {
        const mes = await Promise.reject(response["json"]());
        return mes;
      }
    })
    .catch(async (error) => {
      // if (error) CHECK_ERROR(error.message)
      return Promise.resolve(error).then((err) => {
        !noAlert && err.message && CHECK_WARNING(err.message);
        if (err.statusCodes === 300) {
          return Promise.reject({ ...err, isChangePass: true });
        }
        if (isDataError) err = { ...err, dataError: JSON.parse(body) };
        return Promise.reject(err);
      });
    })
    .finally(() => method !== "GET" && !noLoading && closeLoading());
};

/**
 * Gọi Fetch API
 * @param {string} url // Đường dẫn chính xác của API
 * @param {ExportFetchType} conf // Tùy chỉnh fetch API
 * @param {BodyInit | null} body // Dữ liệu gửi lên API
 */
// Make a request using the Fetch API
export function FetchMapping(url, conf, body) {
  return exportFetch({ ...conf, url, body });
}

/**
 * Gọi Fetch API phương thức GET không cần đăng nhập
 * @param {string} url // Đường dẫn chính xác của API
 * @param {Pick<ExportFetchType, 'noAlert' | 'responseType'>} conf Tùy chỉnh fetch API
 */
export function GetMappingPublic(url, conf) {
  return exportFetch({
    ...conf,
    prefix: _API_URL,
    method: "GET",
    url,
    body: null,
  });
}

/**
 * Gọi Fetch API phương thức GET
 * @param {string} url // Đường dẫn chính xác của API
 * @param {Pick<ExportFetchType, 'noAlert' | 'responseType'>} conf Tùy chỉnh fetch API
 */
export function GetMappingAuthorization(url, conf) {
  return exportFetch({
    ...conf,
    prefix: _API_URL,
    method: "GET",
    url,
    body: null,
  });
}

/**
 * Gọi Fetch API phương thức POST không cần đăng nhập
 * @param {String} url // Đường dẫn chính xác của API
 * @param {BodyInit | null} body // Dữ liệu gửi lên API
 * @param {Pick<ExportFetchType, 'noAlert' | 'responseType'>} conf Tùy chỉnh fetch API
 */
export function PostMappingPublic(url, body, conf) {
  return exportFetch({ ...conf, prefix: _API_URL, method: "POST", url, body });
}

/**
 * Gọi Fetch API phương thức POST BATCH
 * @param {String} url // Đường dẫn chính xác của API
 * @param {BodyInit | null} body // Dữ liệu gửi lên API
 * @param {Pick<ExportFetchType, 'noAlert' | 'responseType'>} conf Tùy chỉnh fetch API
 */

export function BatchAuthorization(urlBatch, data, endpoint) {
  // const body = CreateListFetch(urlBatch, url, data);
  return exportFetch({
    prefix: _API_URL,
    method: "POST",
    url: urlBatch + "/$batch",
    body: data,
    endpoint,
    isBatch: true,
    noLoading: true,
  });
}

/**
 * Gọi Fetch API phương thức POST
 * @param {String} url // Đường dẫn chính xác của API
 * @param {BodyInit | null} body // Dữ liệu gửi lên API
 * @param {Pick<ExportFetchType, 'noAlert' | 'responseType'>} conf Tùy chỉnh fetch API
 * @param {string} refreshToken refresh token
 */
export function PostMappingAuthorization(url, body, conf, refreshToken) {
  return exportFetch({
    ...conf,
    prefix: _API_URL,
    method: "POST",
    url,
    body,
    refreshToken,
  });
}

/**
 * Gọi Fetch API phương thức PUT
 * @param {String} url // Đường dẫn chính xác của API
 * @param {BodyInit | null} body // Dữ liệu gửi lên API
 * @param {Pick<ExportFetchType, 'noAlert' | 'responseType'>} conf Tùy chỉnh fetch API
 */
export function PutMappingAuthorization(url, body, conf) {
  return exportFetch({ ...conf, prefix: _API_URL, method: "PUT", url, body });
}

/**
 * Gọi Fetch API phương thức PATCH
 * @param {String} conf.url // Đường dẫn chính xác của API
 * @param {BodyInit | null} body // Dữ liệu gửi lên API
 * @param {Pick<ExportFetchType, 'noAlert' | 'responseType'>} conf Tùy chỉnh fetch API
 */
export function PatchMappingAuthorization(url, body, conf) {
  return exportFetch({ ...conf, prefix: _API_URL, method: "PATCH", url, body });
}

/**
 * Gọi Fetch API phương thức DELETE
 *
 * @param {String} url // Đường dẫn chính xác của API
 * @param {Pick<ExportFetchType, 'noAlert' | 'responseType'>} conf Tùy chỉnh fetch API
 */
export function DeleteMappingAuthorization(url, conf, body) {
  return exportFetch({
    ...conf,
    prefix: _API_URL,
    method: "DELETE",
    url,
    body,
  });
}
